import React from 'react';
import { Platform, View, Text, StyleSheet } from 'react-native';

/**
 * Wraps a route element so it only renders on the web. On native (iOS/Android)
 * it shows a friendly fallback so we never try to render DOM-heavy admin/web
 * pages and crash the app.
 *
 * Use this for routes that intentionally use raw DOM/Tailwind markup, such as
 * the admin section.
 */
const WebOnlyRoute = ({
  children,
  message,
}: {
  children: React.ReactNode;
  message?: string;
}) => {
  if (Platform.OS !== 'web') {
    return (
      <View style={styles.container}>
        <Text style={styles.title}>Open in a web browser</Text>
        <Text style={styles.body}>
          {message ?? 'This page is only available on the web. Please open it in your browser.'}
        </Text>
      </View>
    );
  }

  return <>{children}</>;
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 24,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f9fafb',
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
    color: '#111827',
    marginBottom: 8,
    textAlign: 'center',
  },
  body: {
    fontSize: 14,
    color: '#4b5563',
    textAlign: 'center',
    maxWidth: 320,
  },
});

export default WebOnlyRoute;
